import { configureStore } from '@reduxjs/toolkit';
import { apiReducer } from './Slices/api.slice';
import syncReducer from './Slices/sync.slice';

// Phase 0.6 cleanup (2026-05-15): الـ feature slices اللي كانت Phase 4.x migration
// (hr/auth/pos/accounting/shared/warehouse) اتأرشفت في `Slices/features/_archive/`
// لأنها dead code (0 selectors). الـ canonical store الفعلي = `api.slice` + `sync`.
// راجع `phase-0.5-reality-check.md` للتفاصيل.

export const store = configureStore({
  reducer: {
    api: apiReducer,
    sync: syncReducer,
  },
});

export default store;
